export interface PatentSearchRequest {
    q: string;
    limit?: number;
}

export interface PatentSearchItem {
    pn: string;
    apno: string;
    title: string;
    application_date: string;
    assignee: string[];
    patent_id: string;
}

export interface PatentSearchResponse {
    status: boolean;
    error_code: number;
    error_msg?: string;
    data?: {
        patents: PatentSearchItem[];
        total: number;
    };
}

export const PatentSearchApi = Symbol('PatentSearchApi');

export interface PatentSearchApi {
    searchPatent(request: PatentSearchRequest): Promise<PatentSearchResponse>;
}
